module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/flexible@2x-ac8c84331e71e8a2191a8c52c005db97.png";